<template>
  <customModal
    :containermd="true"
    :bodymd="true"
    :footerShow="false"
    @closeModal="closeSetVersion()"
  >
    <!-- Modal Title -->
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.lab reference") }}
      </h4>
    </template>

    <template #body>
      <div class="ibox-content-edit">
        <div class="ibox-body">
          <!-- Header Section -->
          <div class="ibox-title style_2 d-flex justify-content-between align-items-center">
            <h4 class="my-0">
              {{
                isEditing
                  ? ($t("navigations.update lab reference") || "Edit  Lab Reference")
                  : ($t("navigations.create lab reference") || "Create Lab Reference")
              }}
            </h4>
          </div>

          <!-- Form Section -->
          <div class="ibox-content">
            <div class="form-group row">
              <div class="col-md-6">
                <label>{{ $t("navigations.version no") }}
                  <sup><i class="fa fa-asterisk imp"></i></sup>
                </label>
                <input v-model="versionNo" type="number" class="form-control" />
              </div>

              <div class="col-md-6">
                <label>{{ $t("navigations.unit") }}
                  <sup><i class="fa fa-asterisk imp"></i></sup>
                </label>
                <select v-model="unit" class="form-control" :disabled="isEditing">
                  <option value="mg/ml">{{ $t("navigations.mg/ml") || "Mg/Ml" }}</option>
                  <option value="mg">{{ $t("navigations.mg") || "Mg" }}</option>
                  <option value="ml">{{ $t("navigations.ml") || "Ml" }}</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label>{{ $t("navigations.subject classification") }}</label>
                <select v-model="gender" class="form-control">
                  <option value="">{{ $t("navigations.select") }}</option>
                  <option value="Male">{{ $t("navigations.male") || "Male" }}</option>
                  <option value="Female">{{ $t("navigations.female") || "Female" }}</option>
                  <option value="Pregnant">{{ $t("navigations.pregnant") || "Pregnant" }}</option>
                  <option value="All">{{ $t("navigations.pregnant") || "Pregnant" }}</option>
                </select>
              </div>

              <div class="col-md-4">
                <label>{{ $t("navigations.min age") }}</label>
                <input v-model.number="ageMin" type="number" class="form-control" />
                <span v-if="ageErrors && ageErrors[0]" class="errormsg">
                  {{ $t("navigations.please enter a value") }}
                </span>
              </div>

              <div class="col-md-4">
                <label>{{ $t("navigations.max age") }}</label>
                <input v-model.number="ageMax" type="number" class="form-control" />
                <span v-if="ageErrors && ageErrors[1]" class="errormsg">
                  {{ $t("navigations.please enter a value") }}
                </span>
                <span v-if="ageErrors && ageErrors[2]" class="errormsg">
                  {{ $t("navigations.max must be greater than min") || "Max age must be >= Min age" }}
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr style="border-top: 1px solid #dcdcdc; margin: 15px 0;" />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label>{{ $t("navigations.min range") }}
                  <sup><i class="fa fa-asterisk imp"></i></sup>
                </label>
                <input v-model.number="minRange" type="number" class="form-control" />
                <span v-if="rangeErrors && rangeErrors[0]" class="errormsg">
                  {{ $t("navigations.please enter a value") }}
                </span>
              </div>

              <div class="col-md-4">
                <label>{{ $t("navigations.max range") }}
                  <sup><i class="fa fa-asterisk imp"></i></sup>
                </label>
                <input v-model.number="maxRange" type="number" class="form-control" />
                <span v-if="rangeErrors && rangeErrors[1]" class="errormsg">
                  {{ $t("navigations.please enter a value") }}
                </span>
              </div>

              <div class="col-md-4">
                <label>{{ $t("navigations.range severity") }}
                  <sup><i class="fa fa-asterisk imp"></i></sup>
                </label>
                <select v-model="rangeSeverity" class="form-control">
                  <option value="low">{{ $t("navigations.low") || "Low" }}</option>
                  <option value="very_low">{{ $t("navigations.very low") || "Very Low" }}</option>
                  <option value="high">{{ $t("navigations.high") || "High" }}</option>
                  <option value="very_high">{{ $t("navigations.very high") || "Very High" }}</option>
                </select>
              </div>
            </div>

            <div class="text-end mt-3">
              <button type="button" class="save_btn py-1 px-4" @click="saveVersion">
                {{ isEditing ? $t("navigations.update") : $t("navigations.save") }}
              </button>
            </div>
          </div>
        </div>

        <!-- List Section -->
        <div class="ibox-content">
          <h4 class="mb-3">
            {{ $t("navigations.range list") || "Test Range Version List" }}
          </h4>

          <div class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>Gender</th>
                  <th>Age Min</th>
                  <th>Age Max</th>
                  <th>Unit</th>
                  <th>Version No</th>
                  <th>Is Active</th>
                  <th class="text-center">{{ $t("navigations.edit") }}</th>
                  <th class="text-center">{{ $t("navigations.delete") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="result in versionList" :key="result.id">
                  <td>{{ result.gender }}</td>
                  <td>{{ result.ageMin }}</td>
                  <td>{{ result.ageMax }}</td>
                  <td>{{ result.unit }}</td>
                  <td>{{ result.versionNo }}</td>
                  <td>{{ result.isActive ? "Yes" : "No" }}</td>
                  <td class="text-center">
                    <i class="fa fa-edit edit-delete" @click.prevent="editVersion(result.id)"></i>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-trash edit-delete" @click.prevent="deleteVersion(result.id)"></i>
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              class="col-md-12 d-flex justify-content-md-end px-0"
              v-if="versionList.length != 0"
            >
              <VPagination
                v-model="currentPage"
                :pages="totalPages"
                :range-size="1"
                active-color="#ededed"
                @update:modelValue="getVersionList"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./SetTestVersionModal.js"></script>

<style scoped>
.data-grid {
  margin-top: 20px;
}

.errormsg {
  color: red;
  font-size: 12px;
}
</style>
